module.exports = __webpack_public_path__ + "static/media/N3.93d5a262.png";